import { Notify } from 'utils';

export const errHelper = (err: any) => {
  const isErrResponse = err && err.response;
  const isMessageProvided = isErrResponse && err.response.data.message;

  if (!isErrResponse) {
    return Notify.error('Application Error');
  }
  if (err.response.status !== 500 && isMessageProvided) {
    return Notify.error(err.response.data.message);
  }
};
